import { useMutation } from '@tanstack/react-query'
import { api } from '@api'

interface ResetPasswordRequest {
  token: string
  newPassword: string
}

const resetPassword = async ({
  token,
  newPassword,
}: ResetPasswordRequest): Promise<void> => {
  await api.post('/authentication/reset-password', { token, newPassword })
}

export const useResetPassword = () => {
  return useMutation<void, Error, ResetPasswordRequest>({
    mutationFn: resetPassword,
  })
}
